<template>
  <div>
    <v-tabs v-model="tab" centered>
      <v-tab>{{ $t('menuHeaders.reportedByContractor')}}</v-tab>
      <v-tab>{{ $t('menuHeaders.reportedByEmployer')}}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <CommonVariationView
          type="claim"
          reporter="contractor"
          :contract="contract"
          :items="contractorClaims"
          @FETCH_DATA="handleFetchData"
          :form-fields="formFields"
        />
      </v-tab-item>
      <v-tab-item>
        <CommonVariationView
          type="claim"
          reporter="employer"
          :contract="contract"
          :items="employerClaims"
          @FETCH_DATA="handleFetchData"
          :form-fields="formFields"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { getVariationsForContract } from '../services'
import { SITES } from '@/helpers'

export default {
  name: 'ClaimsView',
  props: {
    contract: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      items: [],
      tab: 0,
      formFields: ['stage', 'workstream', 'category', 'unlock', 'toVariation', 'stageChange']
    }
  },
  computed: {
    employerClaims () {
      return this.items.filter(i => i.reportingSide === SITES.employer)
    },
    contractorClaims () {
      return this.items.filter(i => i.reportingSide === SITES.contractor)
    }
  },
  mounted () {
    if (this.contract && this.contract.id) {
      this.handleFetchData(this.contract.id)
    }
  },
  methods: {
    async handleFetchData () {
      this.items = await getVariationsForContract(this.contract.id, 'claim')
    }
  },
  watch: {
    contract () {
      this.handleFetchData()
    }
  }
}
</script>
